// 簽到資料 個人
import * as types from '../actionType';

let initState = {
  records: [],
  count: 3,
};

function personsSignInTimeState(state = initState, action) {
  switch (action.type) {
      case types.ATTENDANCE_SHEET_SUCCESS: {
        return action.result;
      }
      default:
        return state;
  }
}


export default personsSignInTimeState;